/**
 * @file Discover Album Folder Faces view.
 */

import React from 'react';

import DiscoverAlbumFolderFacesContainer from '../../containers/discover/DiscoverAlbumFolderFacesContainer';

const DiscoverAlbumFolderFacesView = () => (
  <DiscoverAlbumFolderFacesContainer />
);

export default DiscoverAlbumFolderFacesView;
